import { useDocumentTitle } from '@/hooks/document-title'
import { observer } from 'mobx-react-lite'
import { useFeatures } from '@/contexts/root-store-context'
import { useActivation } from '@/hooks/view-model-hooks'
import { Id } from '@/infra/id'
import styles from './WaitlistView.module.css'
import { useEffect, useMemo } from 'react'
import { useNavigate } from 'react-router'
import { links } from '@/utils/link'
import { usePageExitMethod } from '@/features/shell/exiting/exit-method-hooks'

export default observer(function WaitlistView() {
  useDocumentTitle('Waitlist')

  const {
    internal: { waitlistVm },
  } = useFeatures((rootStore) => ({
    internal: rootStore.waitlist.internal(),
  }))

  const { execute } = usePageExitMethod()
  useActivation(waitlistVm)

  const navigate = useNavigate()

  useEffect(() => {
    const handleMessage = (event: MessageEvent<{ action: string }>) => {
      if (event.origin !== 'https://www.taxfyle.com') {
        return
      }

      // Handle navigation action
      if (event.data.action === 'navigate') {
        void navigate(links.home())
        return
      }

      // handle a close command from the iframe and pass it up
      if (event.data.action === 'close') {
        execute()
      }
    }

    // Add event listener
    window.addEventListener('message', handleMessage)

    // Cleanup on unmount
    return () => {
      window.removeEventListener('message', handleMessage)
    }
  }, [navigate, execute])

  const waitlistParams = useMemo(() => {
    return new URLSearchParams({
      first_name: waitlistVm.member.user.givenName,
      last_name: waitlistVm.member.user.familyName,
      workspace_id: Id.assert(waitlistVm.member.workspace.id),
      email: waitlistVm.member.user.email ?? '',
      phone: waitlistVm.member.user.phone ?? '',
    })
  }, [waitlistVm.member])

  return (
    <div className={styles.container}>
      <iframe
        className={styles.iframe}
        title="Join the Waitlist"
        src={`https://www.taxfyle.com/taxfiling-waitlist?${waitlistParams.toString()}`}
      />
    </div>
  )
})
